/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/modals/modals.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/accordion/accordion.ts" />
/// <reference path="../accounting/accounting.ts" />

namespace OfficeGuy.Apps {
    export class Expenses {
        static Upload_FileChanged($Input): void {
            var Input = <HTMLInputElement>$Input[0];
            if (!Input.files || !Input.files[0])
                return;

            var PendingCount = Input.files.length;
            var $Container = $(".sumit-books-file-upload-container").empty();
            var AdditionalQuickUploadDetails = new Array();
            var Process = function (File, $Item) {
                var Data = new FormData();
                Data.append('Files', File);

                if ($Item == null) {
                    $Item = $('<div class="sumit-field sumit-field-display">')
                        .append($('<div class="sumit-field-value">')
                            .append($('<div class="sumit-books-file-upload">')
                                .append($('<div class="sumit-books-file-upload-filename">').text(File.name))
                                .append($('<div class="sumit-books-file-upload-status sumit-books-file-upload-status-loading"></div>')
                                )
                            )
                        )
                        .appendTo($Container);
                }
                Common.AjaxRequest({
                    URL: '/expenses/upload/',
                    Data: Data,
                    ContentType: false,
                    ProcessData: false,
                    ShowLoading: false,
                    SuccessMethod: function (Response) {
                        if (Response.AdditionalQuickUploadDetails != null)
                            AdditionalQuickUploadDetails = AdditionalQuickUploadDetails.concat(Response.AdditionalQuickUploadDetails);
                        if (--PendingCount == 0) {
                            if (AdditionalQuickUploadDetails.length > 0)
                                Modals.ShowURLModal("/expenses/quickexpensedetails/?documentids=" + AdditionalQuickUploadDetails.join(','));
                        }
                        $Item.find(".sumit-books-file-upload-status").removeClass("sumit-books-file-upload-status-loading");
                        $Item.find(".sumit-books-file-upload").addClass("sumit-books-file-upload-valid");
                    },
                    ErrorMethod: function () {
                        PendingCount--;
                        $Item.find(".sumit-books-file-upload-status")
                            .removeClass("sumit-books-file-upload-status-loading")
                            .addClass("sumit-books-file-upload-status-error");
                        $Item.find('.sumit-field-value')
                            .append($('<a class="sumit-field-display-error">הקובץ לא עלה! לניסיון חוזר לחצו כאן.</a>')
                                .one("click", function () {
                                    $Item.find(".sumit-field-display-error").remove();
                                    $Item.find(".sumit-books-file-upload-status")
                                        .removeClass("sumit-books-file-upload-status-error")
                                        .addClass("sumit-books-file-upload-status-loading");
                                    Process(File, $Item);
                                })
                            );
                    },
                    RetriesPending: 3
                });
            };
            for (var i = 0; i < Input.files.length; i++) {
                var File = Input.files[i];
                Process(File, null);
            }
            Input.val('');
            $Input.trigger('change');
        }

        static FileExpense_Init($Container, CustomerCorporateNumberPropertyID) {
            Expenses.Quick_InitForm($Container, true);
            Expenses.Quick_InitDate($Container);

            $(".og-expenses-quick-total input", $Container).on("change", function () {
                Expenses.FileExpense_UpdateTotalVAT($Container, $(this).attr("id"));
            });
            Expenses.RefreshForeignCurrency($Container);

            $(".og-expenses-quick-ocr", $Container).on("click.expenses-filequick", function () {
                if ($(this).hasClass("og-expenses-quick-ocr-customer")) {
                    var CorporateNumber = $(this).data("corporatenumber").toString();
                    var SupplierName = $(this).data("name").toString();
                    var ItemID = $(this).data("itemid");
                    if (ItemID != 0) {
                        var ItemSelectBox = Teva.SelectBox.GetInstance($(this).closest(".og-expenses-quick").find(".og-expenses-quick-item input.entitypicker:hidden"));
                        if (ItemSelectBox.SelectedValue == "" || ItemSelectBox.SelectedValue == "0")
                            ItemSelectBox.SetValue(ItemID.toString(), $(this).data("itemname"), []);
                    }
                    var CustomerID = $(this).data("customerid").toString();
                    var CustomerSelectBox = Teva.SelectBox.GetInstance($(this).closest(".sumit-field").find("input.entitypicker"));
                    if (CustomerID.length == 0 || CustomerID == "0") {
                        if (SupplierName.length != 0)
                            CustomerSelectBox.SetValue(-Number(CorporateNumber), SupplierName + " (" + CorporateNumber + ")", {});
                        else
                            OfficeGuy.CRM.EntityPicker.New($(this).closest(".sumit-field").find(".entitypickercontainer"), $(this).closest(".sumit-field").find("input.entitypicker").data("schemaid"), "ספק/ית ללא שם", "&defaultproperty_1=" + CustomerCorporateNumberPropertyID + "&defaultvalue_1=" + CorporateNumber);
                    }
                    else
                        CustomerSelectBox.SetValue(CustomerID, SupplierName + " (" + CorporateNumber + ")", { schemaid: $(this).data("customerschemaid") });
                }
                else {
                    var Value = this.innerText;
                    $(this).closest(".sumit-field").find("input").val(Value).trigger("change");
                }
                return false;
            });
            $(".og-expenses-quick-preview", $Container).each(function () {
                var $Image = $(this).find("img");
                if ($Image.length == 0)
                    return;
                $Image.data("OriginalSrc", $Image.attr("src")).data("rotate", 0);

                var $Buttons = $(document.createElement('div'))
                    .addClass("og-expenses-quick-preview-buttons")
                    .insertAfter($Image);

                $(document.createElement('div')
                    .addClass("og-expenses-quick-preview-buttons-button", "og-expenses-quick-preview-buttons-button-clockwise")
                )
                    .on("click", function () {
                        var Rotate = ($Image.data("rotate") + 90) % 360;
                        Navigation.Loading_Show();
                        $Image
                            .data("rotate", Rotate)
                            .on("load", function () {
                                Navigation.Loading_Hide();
                            });
                        if (Rotate == 0)
                            $Image.attr("src", $Image.data("OriginalSrc"));
                        else
                            $Image.attr("src", $Image.data("OriginalSrc") + "?rotate=" + Rotate);

                        return false;
                    }).appendTo($Buttons);
                $(document.createElement('div')
                    .addClass("og-expenses-quick-preview-buttons-button", "og-expenses-quick-preview-buttons-button-counterclockwise")
                )
                    .on("click", function () {
                        Navigation.Loading_Show();
                        var Rotate = ($Image.data("rotate") + 270) % 360;
                        $Image
                            .data("rotate", Rotate)
                            .on("load", function () {
                                Navigation.Loading_Hide();
                            });
                        if (Rotate == 0)
                            $Image.attr("src", $Image.data("OriginalSrc"));
                        else
                            $Image.attr("src", $Image.data("OriginalSrc") + "?rotate=" + Rotate);
                        return false;
                    }).appendTo($Buttons);
            });
            $(".og-expenses-quick-documentdefinition input:hidden", $Container).on("change", function () {
                var DocumentDefinition = $(this).val();
                Teva.SlideOrFade.Toggle($(".og-expenses-quick-paymentmethod, .og-expenses-quick-paymentdate", $Container), DocumentDefinition == '13' || DocumentDefinition == '15');
                Teva.SlideOrFade.Toggle($(".og-expenses-quick-item", $Container), DocumentDefinition == '13' || DocumentDefinition == '14' || DocumentDefinition == '31');
                Teva.SlideOrFade.Toggle($(".og-expenses-quick-invoicenumber", $Container), DocumentDefinition == '13' || DocumentDefinition == '14' || DocumentDefinition == '31');
                Expenses.FileExpense_UpdateTotalVAT($Container, "");
            }).trigger("change");
            Forms.ClearDirty($Container.find("form"));
        }

        static RefreshForeignCurrency($Container: JQuery) {
            $(".og-accounting-currency input.currencypicker, .og-accounting-currencysettings-currency input.currencypicker", $Container).on("change.accounting-currency", function () {
                var IsCurrencySettings = $('.og-accounting-currencysettings-currency').is(":visible");
                if (!$(".og-accounting-currencysettings .og-notification-fixed", $Container).hasClass("hide"))
                    $(".og-accounting-currencysettings .og-notification-fixed", $Container).addClass("hide");

                if (IsCurrencySettings)
                    Teva.SelectBox.GetInstance($(".og-accounting-currency input.currencypicker")).SetValueFromQueryMethod($(this).val());
                else if ($(".og-accounting-currencysettings-currency input.currencypicker").length > 0)
                    Teva.SelectBox.GetInstance($(".og-accounting-currencysettings-currency input.currencypicker")).SetValueFromQueryMethod($(this).val());

                $(".og-accounting-currencysettings-exchangerate input", $Container).val("");
                $(".og-accounting-currencysettings-customexchangerate input", $Container).val("False");
                $(".og-accounting-currencysettings-exchangerate", $Container).toggle(SelectedCurrency != "1");
                $(".og-accounting-currencysettings-foreigncurrencyinput", $Container).toggle(SelectedCurrency != "1");

                var SelectedCurrency = $(this).val();
                if (SelectedCurrency == "1")
                    $(".og-accounting-currencysettings-foreigncurrencyinput input", $Container).prop("checked", SelectedCurrency != "1");
                else {
                    $(".og-accounting-currencysettings-foreigncurrencyinput input", $Container).prop("checked", true);
                    if (!IsCurrencySettings) {
                        var $Modal = Modals.ShowHTMLDialog({
                            HTML: $(".og-accounting-currencysettings", $Container),
                            Title: "הגדרות מטבע",
                            HideEvent: function () {
                                if ($(".og-accounting-currencysettings-exchangerate input", $Container).val() == "0")
                                    $(".og-accounting-currencysettings-exchangerate input", $Container).val("");
                                if ($(".og-accounting-currencysettings-exchangerate input", $Container).val() != "")
                                    $(".og-accounting-currencysettings-customexchangerate input", $Container).val("True");
                            },
                            Buttons: [
                                $(document.createElement('button'))
                                    .attr("type", "button")
                                    .addClass("og-button-ui-action og-button-color-default")
                                    .text(OfficeGuy.Resources.GetString("Modal", "Approve"))
                                    .on("click", function () {
                                        Accounting.ToggleForeignCurrency($(".og-accounting-currencysettings-foreigncurrencyinput input", $Container).prop("checked"));
                                        Modals.Hide($Modal);
                                        return true;
                                    })
                            ]
                        });
                    }
                }

                Accounting.ToggleForeignCurrency(SelectedCurrency != "1");
                Expenses.FileExpense_RefreshLabel($Container);
            });
        }
        static FileExpense_UpdateTotalVAT($Container: JQuery, ChangedElementID: string) {
            Expenses.FileExpense_RefreshLabel($Container);
            return false;
        }
        static FileExpense_RefreshLabel($Container) {
            var $TotalLabel = $("label[for='Total']", $Container);
            var Text = "";
            if ($TotalLabel.data("original-text"))
                Text = $TotalLabel.data("original-text");
            else {
                Text = $TotalLabel.text();
                $TotalLabel.data("original-text", Text);
            }

            var CurrencyDescription = $(".og-accounting-currency .teva-selectbox-label-text", $Container).text();
            $TotalLabel.text(Text + " ב" + CurrencyDescription);
        }
        static FileExpenses_PreProceed($Form) {
            var $Accordion = $Form.closest(".og-accordion");
            var $Next = $Accordion.next(".og-accordion");
            if ($Next.length > 0)
                Teva.Accordion.LoadAjax($Next, false, false);
        }
        static FileExpenses_Proceed($Form, Status, DocumentName: string = null) {
            var $Accordion = $Form.closest(".og-accordion");
            var $Next = $Accordion.next(".og-accordion");
            var $Header = $Accordion.find(".og-accordion-link-contents");
            if (Status == 0)
                $Header.text($Header.text() + " - נשמרה (" + DocumentName + ")");
            else if (Status == 1)
                $Header.text($Header.text() + " - הוחזרה ללקוח/ה");
            else if (Status == 2)
                $Header.text($Header.text() + " - הועברה לפיצול");
            else if (Status == 3)
                $Header.text($Header.text() + " - הועברה לתיוק הכנסות");
            else
                $Header.text($Header.text() + " - נמחקה לארכיון");
            Teva.Accordion.Hide($Accordion);
            if ($Next.length > 0) {
                Teva.Accordion.Show($Next);
                Teva.Navigation.FocusOnFirstField($Next);
            }
            $Accordion.find("button.og-button-ui-square-icon").attr("disabled", "disabled");
        }

        static QuickCreate_Init() {
            Expenses.Quick_InitForm(null, false);
            Expenses.Quick_InitDate(null);
            OfficeGuy.Forms.ClearDirty();
        }

        static Quick_InitForm($Container, IsFileExpenses) {
            $(".og-expenses-quick form", $Container)
                .on("submit", function (Event) {
                    Expenses.FileExpenses_PreProceed($(Event.target));
                    return true;
                })
                .data("ConvertFormToAjaxEvent", function (Response, $Form) {
                    if (Response.DuplicateMessage != null) {
                        var $Modal = Modals.ShowConfirmDialog({
                            Title: Response.DuplicateTitle,
                            Message: Response.DuplicateMessage,
                            ConfirmText: "חזרה לעריכה",
                            ConfirmEvent: function () {
                                Modals.Hide($Modal);
                            },
                            CancelText: "תיוק סופי",
                            CancelClass: "og-button-color-danger",
                            CancelEvent: function () {
                                Modals.Hide($Modal);
                                $Form.find("input[name=IgnoreExisting]").val(true);
                                Forms.SubmitForm($Form);
                            },
                            CancelAllowed: true
                        });
                        Forms.EnableForm($Form);
                        return;
                    }
                    if (IsFileExpenses)
                        Expenses.FileExpenses_Proceed($Form, 0, Response.DocumentName);
                });
        }
        static Quick_InitDate($Container) {
            $(".og-expenses-quick-documentdefinition input", $Container).on("change", function () {
                $(".og-expenses-quick-date input", $Container).trigger("change.expenses-filequick");
            });

            $(".og-expenses-quick-date input", $Container)
                .on("change.expenses-filequick", function () {
                    $(this).trigger("change.datepicker");
                    var SelectedDate = Teva.DatePicker.GetDateFromString(<string>$(this).val(), Teva.DatePickerMode.Date);
                    if (SelectedDate == null)
                        return;

                    $(this).closest(".og-expenses-quick").find(".og-expenses-quick-paymentdate input").attr("placeholder", <string>$(this).val()).trigger("change");

                    $(this).closest(".input-Date").find(".og-expenses-quick-date-notification").remove();
                    var DocumentDefinition = $(".og-expenses-quick-documentdefinition input:hidden", $Container).val();
                    if (DocumentDefinition == '13' || DocumentDefinition == '14')
                        Accounting.ShowExpenseDateWarning($(this), SelectedDate);
                })
                .trigger("change.expenses-filequick");

        }
        static Quick_SupplierSelected($EntityPicker): void {
            var SelectBox = Teva.SelectBox.GetInstance($EntityPicker);
            var Data = SelectBox.SelectedData;
            if (!Data || !Data.AdditionalFields)
                return;

            var DefaultPaymentMethod = Data.AdditionalFields["Accounting.Customers.Suppliers.DefaultExpenseItem"];
            if (DefaultPaymentMethod != null) {
                var ItemSelectBox = Teva.SelectBox.GetInstance($EntityPicker.closest(".og-expenses-quick").find(".og-expenses-quick-item input.entitypicker:hidden"));
                ItemSelectBox.SetValue(DefaultPaymentMethod.ID, DefaultPaymentMethod.Name, {
                    schemaid: DefaultPaymentMethod.SchemaID
                });
            }
            var DefaultPaymentMethod = Data.AdditionalFields["Accounting.Customers.Suppliers.DefaultPaymentMethod"];
            if (DefaultPaymentMethod != null) {
                var PaymentMethodSelectBox = Teva.SelectBox.GetInstance($EntityPicker.closest(".og-expenses-quick").find(".og-expenses-quick-paymentmethod input:hidden"));
                PaymentMethodSelectBox.SetValueFromQueryMethod(DefaultPaymentMethod.ID);
            }
        }

        static FileExpenses_InitReject(DocumentID) {
            $(".og-expenses-rejectexpense form")
                .on("submit", function (Event) {
                    Expenses.FileExpenses_PreProceed($(Event.target));
                    return true;
                })
                .data("ConvertFormToAjaxEvent", function (Response, Form) {
                    var $FileExpenseForm = $("form#og-expenses-quickform-" + DocumentID);
                    Expenses.FileExpenses_Proceed($FileExpenseForm, 1);
                    OfficeGuy.Modals.Hide(Form.closest(".modal"));
                });
        }
        static FileExpenses_InitArchive(DocumentID, Status) {
            $(".og-expenses-archiveexpense form")
                .on("submit", function (Event) {
                    Expenses.FileExpenses_PreProceed($(Event.target));
                    return true;
                })
                .data("ConvertFormToAjaxEvent", function (Response, Form) {
                    var $FileExpenseForm = $("form#og-expenses-quickform-" + DocumentID);
                    Expenses.FileExpenses_Proceed($FileExpenseForm, Status);
                    OfficeGuy.Modals.Hide(Form.closest(".modal"));
                });
        }
    }
}